import "../scss/style.scss";
import objectFitImages from 'object-fit-images';


jQuery(function ($) {

$(window).on('load resize', function() {
	var ua = navigator.userAgent;
	if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
		$('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
	} else {
		$('head').prepend('<meta name="viewport" content="width=980">');
	}
});



//スムーススクロール
$(function(){
	$('a[href^="#"]').click(function(){
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? "body" : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, 500, "swing");
		return false;
	});
});



//スクロールされたらフェードイン & アップ
$(window).on('load scroll', function() {
	$('.fade-in, .fade-up').each(function(){
		var elemPos = $(this).offset().top;
		var scroll = $(window).scrollTop();
		var windowHeight = $(window).height();
		if (scroll > elemPos - windowHeight + windowHeight/7){
			$(this).addClass('scrollin');
		}
		else {
			$(this).removeClass('scrollin');
		}
	});
});



//【SP】SP版メニュー　クリックイベント
$(document).ready(function(){
	$('.navBtn').on('click',function(){
		if($('#nav').css('display') == 'none'){
			$("#nav").fadeIn(200);
			$(".navBtn .txt").text('CLOSE');
			$(this).addClass('close');
		} else {
			$("#nav").fadeOut(200);
			$(".navBtn .txt").text('MENU');
			$(this).removeClass('close');
     }
	});
	if (window.matchMedia('(max-width:768px)').matches) {
		$('.navBtn.close,#nav').on('click', function () {
			$("#nav").fadeOut(200);
			$('.navBtn.close').removeClass('close');
			$(".navBtn .txt").text('MENU');
		});
	}
});



// object-fit
$(function () {
	objectFitImages('.imgFitBox img,.imgLinkBox img,.imgMv');
});


// スマホ高さ100vh調整
// window.addEventListener('resize', () => {
	// 最初に、ビューポートの高さを取得し、0.01を掛けて1%の値を算出して、vh単位の値を取得
	// let vh = window.innerHeight * 0.01;
	// console.log(vh);
	// カスタム変数--vhの値をドキュメントのルートに設定
// 	document.documentElement.style.setProperty('--vh', vh + 'px');
// });


// 選択した要素が真ん中になるよう調整
$(document).ready(function () {
	var categoryListCurrent = $('.categoryList li.current')
	var categoryListCurrentPosLeft = categoryListCurrent.position().left;
	var categoryListWidth = categoryListCurrent.width();
	var windowWidth = $(window).width();
	var windowLeftPos = ((windowWidth - categoryListWidth) / 2);
	var newCurrentPos = categoryListCurrentPosLeft - windowLeftPos;
	$('.category').scrollLeft(newCurrentPos);
	// console.log(categoryListCurrentPosLeft, categoryListWidth, windowWidth, windowLeftPos);
	return false;
});


$(function() {
	var pagetop = $('.totop');
	pagetop.css({ 'display': 'none'});
  $(window).on('load scroll', function() {
    if ($(this).scrollTop() > 100) {
      pagetop.fadeIn();
    } else {
      pagetop.fadeOut();
    }
  });
});


});
